import * as React from 'react';

function SvgNewBooking(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M12.531 9.744a3 3 0 110 6 3 3 0 010-6zm.7-2.744l.002 1.884a3.932 3.932 0 00-.632-.051c-1.05 0-2.03.386-2.729 1.16a3.836 3.836 0 00-1.154 2.74c0 .854.253 1.662.758 2.312l-6.344-.001a1 1 0 01-1-1V7h11.1zm.291 4.638l-.065.054-1.237 1.237-.649-.648a.417.417 0 00-.642.524l.053.065 1.238 1.238 1.826-1.827a.417.417 0 00-.524-.643zM7.94.578l7.214 4.527a.4.4 0 01-.212.739H.606a.4.4 0 01-.214-.738L7.513.579A.4.4 0 017.94.578z" />
    </svg>
  );
}

export default SvgNewBooking;
